import { render } from "./Media.vue?vue&type=template&id=12e6417c&scoped=true"
import script from "./Media.vue?vue&type=script&lang=js"
export * from "./Media.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-12e6417c"

export default script